import React from "react";
import PropsType from "prop-types";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import { Typography } from "@mui/material";
import Div from "@jumbo/shared/Div";
import { getAssetPath } from "app/utils/appHelpers";
import { ASSET_IMAGES } from "app/utils/constants/paths";

const CounterCard = ({ svg, count, title, backgroundColor, height, width }) => {
  return (
    <JumboCardQuick bgColor={backgroundColor}>
      <Div sx={{ display: "flex", alignItems: "center" }}>
        {svg && (
          <img
            alt={""}
            src={getAssetPath(`${ASSET_IMAGES}/${svg}.svg`)}
            height={height}
            width={width}
          />
        )}
        <Div sx={{ ml: 1.5, flex: 1 }}>
          <Typography color={"common.white"} variant={"h2"} mb={0.5}>
            {count}
          </Typography>
          <Typography color={"common.white"} variant={"h5"} mb={0}>
            {title}
          </Typography>
        </Div>
      </Div>
    </JumboCardQuick>
  );
};

CounterCard.propTypes = {
  imagePath: PropsType.string,
  count: PropsType.number,
  title: PropsType.string,
};

CounterCard.defaultProps = {
  backgroundColor: "#23BCBA",
};

export default CounterCard;
